export const getQueryString = (queryObject: Record<string, unknown>) => {
  const queryString = Object.entries(queryObject)
    .map(([name, value]) => (value ? `${name}=${value}` : ""))
    .filter(item => !!item)
    .toString()
    .replaceAll(",", "&");
  return Object.values(queryObject).length ? `?${queryString}` : "";
};
